import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";

export const SectionTitleContainer = styled.div`
  width: 100%;
  height: 112px;
`;

export const TitleText = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.display2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  line-height: ${fipayFonts.fipayFonts.lineHeight.display2};

  color: ${colors.NAVYBLUE};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.sectionTitle};
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.sectionTitle};

    text-align: center;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: center;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: center;
  }
`;

/***************************************************************************** */

export const SectionTitleContainer1 = styled.div`
  width: 100%;
  height: 112px;
`;

export const TitleText1 = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.display2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  line-height: ${fipayFonts.fipayFonts.lineHeight.display2};

  color: ${colors.NAVYBLUE};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.sectionTitle};
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    /* font-size: ${fipayFonts.fipayFonts.heading2.size}; */
    font-size: 26px;
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.sectionTitle};

    text-align: center;
  }

  @media screen and (max-width: 430px) {
    /* font-size: ${fipayFonts.fipayFonts.heading2.size}; */
    font-size: 26px;
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: center;
  }

  @media screen and (max-width: 375px) {
    /* font-size: ${fipayFonts.fipayFonts.heading2.size}; */
    font-size: 26px;
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: center;
  }
`;
